import React from "react";
import "./footer.scss";
import Rootlogo from "../../assets/images/root-logo.svg";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="footer-top"></div>
        <div className="footer-section">
          <div className="leftside">
            <img src={Rootlogo} alt="" />
          </div>
          <div className="middle">
            <span>@2024 The Root. All Rights Reserved</span>
          </div>
          <div className="rightside">
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="27.5078"
                cy="27.5078"
                r="26.0046"
                stroke="#2B2B2B"
                stroke-width="3.00626"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.1882 13C23.0631 13 22.5467 13.0172 20.9266 13.0911C19.3096 13.165 18.2049 13.4222 17.239 13.7979C16.2265 14.1786 15.3081 14.776 14.5487 15.5496C13.7763 16.3081 13.1786 17.2258 12.797 18.2389C12.4234 19.2048 12.1652 20.3105 12.0913 21.9275C12.0183 23.5466 12.0001 24.062 12.0001 28.1881C12.0001 32.3141 12.0173 32.8295 12.0913 34.4496C12.1652 36.0666 12.4223 37.1713 12.798 38.1372C13.1787 39.1498 13.7761 40.0681 14.5497 40.8276C15.3082 41.5999 16.226 42.1976 17.239 42.5792C18.2049 42.9539 19.3096 43.2111 20.9266 43.285C22.5467 43.3589 23.0631 43.3761 27.1882 43.3761C31.3132 43.3761 31.8296 43.3589 33.4497 43.285C35.0667 43.2111 36.1714 42.9539 37.1374 42.5782C38.1499 42.1975 39.0683 41.6001 39.8277 40.8265C40.6 40.068 41.1978 39.1503 41.5794 38.1372C41.954 37.1713 42.2112 36.0666 42.2851 34.4496C42.359 32.8295 42.3762 32.3131 42.3762 28.1881C42.3762 24.063 42.359 23.5466 42.2851 21.9265C42.2112 20.3095 41.954 19.2048 41.5784 18.2389C41.197 17.2254 40.5993 16.3073 39.8267 15.5486C39.0681 14.7762 38.1504 14.1784 37.1374 13.7969C36.1714 13.4232 35.0657 13.165 33.4487 13.0911C31.8296 13.0182 31.3143 13 27.1882 13ZM27.1882 15.7369C31.2434 15.7369 31.7243 15.7521 33.3262 15.825C34.8065 15.8928 35.6105 16.1389 36.1461 16.3485C36.8549 16.6229 37.3611 16.9529 37.8927 17.4835C38.4243 18.0151 38.7534 18.5214 39.0278 19.2301C39.2364 19.7658 39.4834 20.5697 39.5513 22.0501C39.6242 23.6519 39.6393 24.1328 39.6393 28.1881C39.6393 32.2433 39.6242 32.7242 39.5513 34.3261C39.4834 35.8064 39.2374 36.6103 39.0278 37.146C38.7847 37.8057 38.3968 38.4025 37.8927 38.8926C37.4027 39.3968 36.8059 39.7847 36.1461 40.0276C35.6105 40.2362 34.8065 40.4833 33.3262 40.5511C31.7243 40.624 31.2444 40.6392 27.1882 40.6392C23.132 40.6392 22.652 40.624 21.0502 40.5511C19.5698 40.4833 18.7659 40.2372 18.2303 40.0276C17.5705 39.7846 16.9737 39.3967 16.4836 38.8926C15.9796 38.4025 15.5917 37.8056 15.3486 37.146C15.14 36.6103 14.8929 35.8064 14.8251 34.3261C14.7522 32.7242 14.737 32.2433 14.737 28.1881C14.737 24.1328 14.7522 23.6519 14.8251 22.0501C14.8929 20.5697 15.139 19.7658 15.3486 19.2301C15.623 18.5214 15.9531 18.0151 16.4836 17.4835C16.9736 16.9793 17.5705 16.5914 18.2303 16.3485C18.7659 16.1399 19.5698 15.8928 21.0502 15.825C22.652 15.7521 23.133 15.7369 27.1882 15.7369Z"
                fill="#2B2B2B"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.1898 33.2536C26.5243 33.2536 25.8653 33.1225 25.2505 32.8678C24.6356 32.6132 24.077 32.2399 23.6064 31.7693C23.1358 31.2987 22.7625 30.74 22.5078 30.1252C22.2532 29.5103 22.1221 28.8514 22.1221 28.1859C22.1221 27.5203 22.2532 26.8614 22.5078 26.2465C22.7625 25.6317 23.1358 25.073 23.6064 24.6024C24.077 24.1318 24.6356 23.7585 25.2505 23.5039C25.8653 23.2492 26.5243 23.1181 27.1898 23.1181C28.5339 23.1181 29.8229 23.652 30.7733 24.6024C31.7237 25.5528 32.2576 26.8418 32.2576 28.1859C32.2576 29.5299 31.7237 30.8189 30.7733 31.7693C29.8229 32.7197 28.5339 33.2536 27.1898 33.2536ZM27.1898 20.3792C25.1194 20.3792 23.1337 21.2017 21.6697 22.6657C20.2057 24.1297 19.3832 26.1154 19.3832 28.1859C19.3832 30.2563 20.2057 32.242 21.6697 33.706C23.1337 35.17 25.1194 35.9925 27.1898 35.9925C29.2603 35.9925 31.2459 35.17 32.71 33.706C34.174 32.242 34.9965 30.2563 34.9965 28.1859C34.9965 26.1154 34.174 24.1297 32.71 22.6657C31.2459 21.2017 29.2603 20.3792 27.1898 20.3792ZM37.2676 20.2374C37.2676 20.7269 37.0732 21.1962 36.7271 21.5423C36.3811 21.8884 35.9117 22.0828 35.4223 22.0828C34.9328 22.0828 34.4635 21.8884 34.1174 21.5423C33.7713 21.1962 33.5769 20.7269 33.5769 20.2374C33.5769 19.748 33.7713 19.2787 34.1174 18.9326C34.4635 18.5865 34.9328 18.3921 35.4223 18.3921C35.9117 18.3921 36.3811 18.5865 36.7271 18.9326C37.0732 19.2787 37.2676 19.748 37.2676 20.2374Z"
                fill="#2B2B2B"
              />
            </svg>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
            >
              <circle
                cx="27.5233"
                cy="27.5078"
                r="26.0046"
                stroke="#2B2B2B"
                stroke-width="3.00626"
              />
              <path
                d="M35.4761 16H39.4627L30.7528 25.7437L41 39H32.9768L26.6935 30.9591L19.5023 39H15.5135L24.8302 28.5777L15 16.0011H23.2268L28.9068 23.3507L35.4761 16ZM34.0775 36.6653H36.2864L22.0265 18.2127H19.6562L34.0775 36.6653Z"
                fill="#2B2B2B"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="56"
              height="57"
              viewBox="0 0 56 57"
              fill="none"
            >
              <path
                d="M53.5434 28.1058C53.5434 42.8286 41.8704 54.7084 27.5388 54.7084C13.2071 54.7084 1.53414 42.8286 1.53414 28.1058C1.53414 13.3829 13.2071 1.50313 27.5388 1.50313C41.8704 1.50313 53.5434 13.3829 53.5434 28.1058Z"
                stroke="#2B2B2B"
                stroke-width="3.00626"
              />
              <path
                d="M29.5385 21.9903H35.5756L34.5412 27.8064H29.5457V46.0013H22.8436V27.7989H19.0308V21.9825H22.8436V19.4779C22.8436 12.9994 25.6885 10 31.8588 10C33.0263 10 35.0435 10.2359 35.8712 10.472V15.7477C35.4352 15.7019 34.6741 15.6792 33.7357 15.6792C30.706 15.6792 29.5385 16.8591 29.5385 19.9346V21.9903Z"
                fill="#2B2B2B"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
